import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/account_information/404'
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    // 登入
    path: '/login',
    name: 'loginPage',
    component: () => import('../views/loginPage')
  },
  {
    // 登出，for Revit
    path: '/logout',
    name: 'logout',
    component: () => import('../views/logoutPage'),
  },
  {
    // 註冊
    path: '/register',
    name: 'registerPage',
    component: () => import('../views/registerPage')
  },
  {
    // 選擇專案
    path: '/select_organization',
    name: 'selectOrganization',
    component: () => import('../views/selectOrganization'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    path: '/account_information',
    name: 'accountInformation',
    redirect: '/account_information/home',
    component: () => import('../views/accountInformationPage'),
    children: [
      {
        // 總覽
        path: 'home',
        name: 'home',
        component: () => import('../views/homePage'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 個人資料
        path: 'personal_information',
        name: 'personalInfo',
        component: () => import('../views/personalInfo'),
        meta: { requiresAuth: true }
      },
      {
        // 安全性設定
        path: 'security_settings',
        name: 'securitySettings',
        component: () => import('../views/securitySettings'),
        meta: { requiresAuth: true }
      },
      {
        // 組織與權限管理
        path: 'organization_and_permission_management',
        name: 'organizationAndPermissionManagement',
        component: () => import('../views/organizationAndPermissionManagement'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 方案總覽與下載 - 第一頁
        path: 'plan_overview',
        name: 'planOverview',
        component: () => import('../views/planOverview'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 方案總覽與下載 - 第二頁
        path: 'plan_overview_option/:id',
        name: 'planOverviewOption',
        component: () => import('../views/planOverviewOption'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 方案總覽與下載 - 第三頁
        path: 'plan_overview_option_detail/:id',
        name: 'planOverviewOptionDetail',
        component: () => import('../views/planOverviewOptionDetail'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 我的方案與帳單
        path: 'plan_and_billing/:id?',
        name: 'planAndBilling',
        component: () => import('../views/planAndBilling'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 政策頁面
        path: 'policy',
        name: 'policyPage',
        component: () => import('../views/policyPage'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 404
        path: '404',
        name: '404',
        component: () => import('../views/404'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      // only 開發人員
      {
        // 訊息推播
        path: 'message_push',
        name: 'messagePush',
        component: () => import('../views/messagePush'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 訂單管理
        path: 'order_management',
        name: 'orderManagement',
        component: () => import('../views/orderManagement'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 待審核元件
        path: 'unreviewed_components',
        name: 'unreviewedComponents',
        component: () => import('../views/unreviewedComponents'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 使用教學
        path: 'tutorial',
        redirect: "/user_guidebook/create_first_project",
      },
    ],
  },
  {
    // 使用指南
    path: '/user_guidebook',
    name: 'userGuidebook',
    meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false },
    component: () => import('../views/userGuidebook'),
    children: [
      {
        // 建立專案-建立您的第一個xModel Designer專案
        path: 'create_first_project',
        name: 'createFirstProject',
        component: () => import('../views/guideBookPage/project/createFirstProject'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 建立專案-建立與管理您的專案團隊
        path: 'build_and_manage_project_team',
        name: 'buildAndManageProjectTeam',
        component: () => import('../views/guideBookPage/project/buildAndManageProjectTeam'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 3D智慧網格與管線系統-建立與編輯3D智慧網格
        path: 'create_and_edit_3DNode',
        name: 'createAndEdit3DNode',
        component: () => import('../views/guideBookPage/node/createAndEdit3DNode'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 建立幹管
        path: 'create_main_pipe',
        name: 'createMainPipe',
        component: () => import('../views/guideBookPage/mainPipe/createMainPipe'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 泡沫滅火系統(3D)
        path: 'create_foam_system',
        name: 'createFoamSystem',
        component: () => import('../views/guideBookPage/fireSystem/createFoamSystem'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 撒水滅火系統(3D)
        path: 'create_sprinkler_system',
        name: 'createSprinklerSystem',
        component: () => import('../views/guideBookPage/fireSystem/createSprinklerSystem'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 2D轉3D功能說明(23D)
        path: 'description_23D',
        name: 'description_23D',
        component: () => import('../views/guideBookPage/fireSystem/description_23D'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 可受辨識的消防CAD繪圖原則(23D)
        path: 'cadDrawingRule_23D',
        name: 'cadDrawingRule_23D',
        component: () => import('../views/guideBookPage/fireSystem/cadDrawingRule_23D'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 安裝AutoCAD addin與FPS addin
        path: 'autoCAD&FPS_23D',
        name: 'autoCAD&FPS_23D',
        component: () => import('../views/guideBookPage/fireSystem/autoCAD&FPS_23D'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 在AutoCAD中匯出平面參數檔-撒水系統
        path: 'exportCSVfromCAD_sprinkler_system_23D',
        name: 'exportCSVfromCAD_sprinkler_system_23D',
        component: () => import('../views/guideBookPage/fireSystem/exportCSVfromCAD_sprinkler_system_23D'),
        // meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 在AutoCAD中匯出平面參數檔-泡沫系統
        path: 'exportCSVfromCAD_foam_system_23D',
        name: 'exportCSVfromCAD_foam_system_23D',
        component: () => import('../views/guideBookPage/fireSystem/exportCSVfromCAD_foam_system_23D'),
        // meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 預覽平面設計辨識成果
        path: 'previewFPS_23D',
        name: 'previewFPS_23D',
        component: () => import('../views/guideBookPage/fireSystem/previewFPS_23D'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 泡沫滅火系統(23D)
        path: 'foam_system_23D',
        name: 'foamSystem_23D',
        component: () => import('../views/guideBookPage/fireSystem/foamSystem_23D'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 撒水滅火系統(23D)
        path: 'sprinkler_system_23D',
        name: 'sprinklerSystem_23D',
        component: () => import('../views/guideBookPage/fireSystem/sprinklerSystem_23D'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 3D智慧網格與管線系統-新增系統
        path: 'create_system',
        name: 'createSystem',
        component: () => import('../views/guideBookPage/node/createSystem'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      // {
      //   // 3D智慧網格與管線系統-新增系統 (消防系統)
      //   path: 'create_fire_system',
      //   name: 'createFireSystem',
      //   component: () => import('../views/guideBookPage/node/createFireSystem'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      {
        // Auto Routing-建立管線生成項目
        path: 'create_AR_item',
        name: 'createARItem',
        component: () => import('../views/guideBookPage/autoRouting/createARItem'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      // {
      //   // Auto Routing-設定管線參數
      //   path: 'set_pipe_parameter',
      //   name: 'setPipeParameter',
      //   component: () => import('../views/guideBookPage/autoRouting/setPipeParameter'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      {
        // Auto Routing-批次生成管線
        path: 'generate_pipe',
        name: 'generatePipe',
        component: () => import('../views/guideBookPage/autoRouting/generatePipe'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      // {
      //   // Auto Routing-在Auto Routing中引用xRule項目
      //   path: 'import_xrule',
      //   name: 'importXrule',
      //   component: () => import('../views/guideBookPage/autoRouting/importXrule'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      {
        // 設計效益分析報告-查看與下載
        path: 'check_and_download',
        name: 'checkAndDownload',
        component: () => import('../views/guideBookPage/analytics/checkAndDownload'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      // {
      //   // xRule知識經驗資料庫-xRule介紹
      //   path: 'xrule_intro',
      //   name: 'xruleIntro',
      //   component: () => import('../views/guideBookPage/xRule/xruleIntro'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      // {
      //   // xRule知識經驗資料庫-了解「法規資料」
      //   path: 'about_regulation',
      //   name: 'aboutRegulation',
      //   component: () => import('../views/guideBookPage/xRule/aboutRegulation'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      // {
      //   // xRule知識經驗資料庫-新增與管理「設計規範」
      //   path: 'create_and_manage_design_rule',
      //   name: 'createAndManageDesignRule',
      //   component: () => import('../views/guideBookPage/xRule/createAndManageDesignRule'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      // {
      //   // xRule知識經驗資料庫-新增與管理「知識經驗」
      //   path: 'create_and_manage_knowledge_experience',
      //   name: 'createAndManageKnowledgeExperience',
      //   component: () => import('../views/guideBookPage/xRule/createAndManageKnowledgeExperience'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      // {
      //   // xRule知識經驗資料庫-保存資料
      //   path: 'save_xrule',
      //   name: 'saveXrule',
      //   component: () => import('../views/guideBookPage/xRule/saveXrule'),
      //   meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      // },
      {
        // xObject元件庫-xObject元件庫介紹
        path: 'xobject_intro',
        name: 'xobjectIntro',
        component: () => import('../views/guideBookPage/xObject/xobjectIntro'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // xObject元件庫-搜尋與使用xObject元件
        path: 'search_and_use_xobject',
        name: 'searchAndUseXobject',
        component: () => import('../views/guideBookPage/xObject/searchAndUseXobject'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // xObject元件庫-自製xObject元件
        path: 'create_xobject',
        name: 'createXobject',
        component: () => import('../views/guideBookPage/xObject/createXobject'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // xObject元件庫-如何上傳建置的xObject元件
        path: 'upload_xobject',
        name: 'uploadXobject',
        component: () => import('../views/guideBookPage/xObject/uploadXobject'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // xObject元件庫-管理與使用我的xObject
        path: 'about_my_xobject',
        name: 'aboutMyXobject',
        component: () => import('../views/guideBookPage/xObject/aboutMyXobject'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 設計演算法-選擇演算法
        path: 'select_algorithm',
        name: 'selectAlgorithm',
        component: () => import('../views/guideBookPage/algorithm/selectAlgorithm'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 設計演算法-演算法介紹
        path: 'algorithm_intro',
        name: 'algorithmIntro',
        component: () => import('../views/guideBookPage/algorithm/algorithmIntro'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 閥組功能-建立、編輯與使用閥組
        path: 'crate_edit_use_accessary',
        name: 'crateEditUseAccessary',
        component: () => import('../views/guideBookPage/accessary/crateEditUseAccessary'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 閥組功能-新增與編輯閥件
        path: 'add_and_edit_accessary',
        name: 'addAndEditAccessary',
        component: () => import('../views/guideBookPage/accessary/addAndEditAccessary'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
    ]
  },
  {
    // 使用指南
    path: '/policy',
    name: 'policy',
    meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false },
    component: () => import('../views/userGuidebook'),
    children: [
      {
        // 隱私權政策
        path: 'privacy_policy',
        name: 'privacyPolicy',
        component: () => import('../views/policyPage/privacyPolicy'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 可接受的使用政策
        path: 'acceptable_use_policy',
        name: 'acceptableUsePolicy',
        component: () => import('../views/policyPage/acceptableUsePolicy'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
      {
        // 軟體授權合約
        path: 'license_agreement',
        name: 'licenseAgreement',
        component: () => import('../views/policyPage/licenseAgreement'),
        meta: { requiresAuth: false, logOutlogOutStatusCannotEnter: false }
      },
    ]
  },
  {
    // 安全性設定 - 刪除帳戶與資料
    path: '/delete_account',
    name: 'deleteAccount',
    component: () => import('../views/deleteAccount'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // 安全性設定 - 恢復帳號與資料
    path: '/restore_account_and_data',
    name: 'restoreAccountAndData',
    component: () => import('../views/restoreAccountAndData'),
    meta: { requiresAuth: true }
  },
  {
    // 刪除組織
    path: '/delete_org',
    name: 'deleteOrg',
    component: () => import('../views/deleteOrg'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // 恢復組織
    path: '/restore_org',
    name: 'restoreOrg',
    component: () => import('../views/restoreOrg'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // 啟用序號
    path: '/check_serial_number',
    name: 'checkSerialNumber',
    component: () => import('../views/checkSerialNumber'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
